import React from 'react';

import { WraperWelcomBanner } from './styles';
import {
  CasinoBonusBlock,
  FooterPartnersBlock,
  ActivationCodeBlock,
} from './components';
import { Box } from '@/shared/ui/box';

export const WelcomBannerSignUp = () => {
  return (
    <WraperWelcomBanner>
      <Box
        $display="flex"
        $flexDirection="column"
        $justifyContent="flex-end"
        $height="100%"
        $gap="18px"
      >
        <CasinoBonusBlock />
        <ActivationCodeBlock />
        <FooterPartnersBlock />
      </Box>
    </WraperWelcomBanner>
  );
};
